import React from 'react';

const AdditionalInfo = props => {
  const { additionalInfo, handleChange } = props;
  return (
    <textarea
      className="form-control"
      type="textarea"
      name="additionalInfo"
      onChange={handleChange}
      value={additionalInfo}
      rows={6}
      maxLength={1000}
    />
  );
};

export default AdditionalInfo;



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageProfile/AdditionalInfo/index.js